import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { RQ_USER } from '@/api/key';
import { getUserDetail } from '@/api/user';
import './Home.css';

const Home: React.FC = () => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');

  const { data, isLoading, isError } = useQuery({
    queryKey: [RQ_USER],
    queryFn: async () => {
      const response = await getUserDetail();
      if (!response || response.status >= 400) {
        throw new Error(response.message);
      }
      return response;
    },
  });

  if (isLoading) {
    return (
      <div className="container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="container">
        <p className="error-message">
          Failed to load user data. Please try again.
        </p>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="card">
        <h2 className="user-name">
          Welcome, {userInfo.name || data?.name || 'Guest'}!
        </h2>
        <img src={userInfo.avatar} alt="user avatar" className="user-avatar" />
      </div>
    </div>
  );
};

export default Home;
